import { i18n } from '@lingui/core';
import type { Messages } from '@lingui/core';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import 'dayjs/locale/en';
// Estático: el español va en el bundle principal y se activa en el mismo tick, sin render en blanco.
import { messages as esMessages } from '../../locales/es.po';

// TODO: cambiar cuando se pase a producción "idiomas"
// export const DEFAULT_LOCALE = navigator.language.startsWith('en') ? 'en' : 'es';
export const DEFAULT_LOCALE = 'es';

// Cada llamada toma un número; un `import()` que resuelve tarde no pisa una activación posterior.
let latestActivation = 0;

const apply = (locale: string, messages: Messages) => {
  i18n.load(locale, messages);
  i18n.activate(locale);
  document.documentElement.lang = locale;
  dayjs.locale(locale);
};

// Hasta que hay un locale activo, el I18nProvider de Lingui no dibuja nada. `es` queda activo antes
// de que la llamada vuelva; los demás esperan su chunk. Lo usan las dos ramas (useI18n y FsdContext).
export const activateLocale = async (locale: string) => {
  const activation = ++latestActivation;

  if (locale === 'es') {
    apply(locale, esMessages);
    return;
  }

  let messages: Messages;
  // Sin chunk rechaza y el idioma activo no cambia; si ya hay una activación posterior, no avisa.
  try {
    ({ messages } = await import(`../../locales/${locale}.po`));
  } catch (error) {
    if (activation !== latestActivation) return;
    throw error;
  }
  if (activation !== latestActivation) return;
  apply(locale, messages);
};
